import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { toast } from "../ui/sonner";
import { ConfirmDialog } from "./ConfirmDialog";
import { formatDate } from "../../lib/dateUtils";

export const MatchesTab = () => {
  const [matches, setMatches] = useState(null);
  const [confirmUndo, setConfirmUndo] = useState(null);

  const load = () => {
    api.get("/admin/matches").then(({ data }) => setMatches(data));
  };

  useEffect(() => {
    load();
  }, []);

  const undoMatch = async (matchId) => {
    try {
      await api.put(`/admin/matches/${matchId}/undo`);
      toast.success("Match undone — both Strangers are back to Registered");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't undo match");
    }
  };

  if (matches === null) return <p className="font-medium text-midnight-black/60">Loading matches...</p>;

  return (
    <div data-testid="admin-matches-tab">
      {matches.length === 0 ? (
        <p className="font-medium text-midnight-black/60" data-testid="no-admin-matches">No matches created yet.</p>
      ) : (
        <div className="space-y-3" data-testid="admin-matches-list">
          {matches.map((m) => (
            <div key={m.match_id} className="border border-soft-gray rounded-xl p-4" data-testid={`admin-match-row-${m.match_id}`}>
              <div className="flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <p className="font-extrabold text-sm uppercase">
                    {m.members.map((mem) => mem.stranger_name).join(" + ")}
                    {m.match_score != null && (
                      <span className="ml-2 text-[10px] font-bold tracking-widest uppercase px-2 py-0.5 rounded-full bg-stranger-orange text-clean-white" data-testid={`admin-match-score-${m.match_id}`}>
                        {m.match_score}% match
                      </span>
                    )}
                  </p>
                  <p className="text-xs font-medium text-midnight-black/60">{m.session_title} · {formatDate(m.session_date)}</p>
                </div>
                <Button variant="outline" data-testid={`undo-match-${m.match_id}`} onClick={() => setConfirmUndo(m.match_id)} className="rounded-full font-bold text-xs">
                  UNDO MATCH
                </Button>
              </div>
              {m.match_reasons?.length > 0 ? (
                <ul className="text-xs font-medium text-midnight-black/50 mt-3 list-disc list-inside" data-testid={`admin-match-reasons-${m.match_id}`}>
                  {m.match_reasons.map((r, i) => <li key={i}>{r}</li>)}
                </ul>
              ) : m.match_score == null ? (
                <p className="text-xs text-midnight-black/40 mt-3">Score not recorded — this match was created before scoring was tracked.</p>
              ) : null}
            </div>
          ))}
        </div>
      )}

      <ConfirmDialog
        open={!!confirmUndo}
        onOpenChange={(v) => !v && setConfirmUndo(null)}
        title="Undo this match?"
        description="Both Strangers will be released back to Registered and can be matched again."
        confirmLabel="UNDO MATCH"
        destructive
        onConfirm={() => undoMatch(confirmUndo)}
      />
    </div>
  );
};
